import React, { useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Label } from 'reactstrap';
import { checkNullValue, getUTCDate } from '../utils/Util';
import { AssignedEmpColumnHeader } from '../pages/create-activity/activityHelper';
import { LocationFilterInitialState } from '../utils/Types';
import { useAppDispatch, useAppSelector } from '../store/redux-hooks';
import {
  fetchVillagesOfDistricts,
  locationFilterSelector,
} from '../features/locationFilterSlice';
import KTable from './KTable';
import moment from 'moment';

interface IActivityDetailsProps {
  activity?: any;
}

const MarketingActivityDetails: React.FunctionComponent<
  IActivityDetailsProps
> = ({ activity }) => {
  const locationData: LocationFilterInitialState = useAppSelector(
    locationFilterSelector
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (activity?.employeeList?.length) {
      const districtIds: number[] = Array.from(
        new Set(
          activity.employeeList.map((employee: any) =>
            Number(employee.district)
          )
        )
      );
      const existingDistrictVillages = Object.keys(
        locationData.cityOptions
      ).map((key) => Number(key));
      const districtsWithNoVillages = districtIds.filter(
        (id) => !existingDistrictVillages.includes(id)
      );
      if (districtsWithNoVillages.length) {
        dispatch(
          fetchVillagesOfDistricts({
            districtId: districtsWithNoVillages,
          })
        );
      }
    }
  }, [activity?.employeeList]);

  const getDetails = () => (
    <div className="mt-4 mb-2 pb-2 mx-4">
      <Row>
        <Col xs={6} lg={2}>
          <Label className="mb-0 model-label-name">Year</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.financialYearName)}
          </Label>
        </Col>
        <Col xs={6} lg={2}>
          <Label className="mb-0 model-label-name">Season</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {' '}
            {checkNullValue(activity?.seasonName)}
          </Label>
        </Col>
        <Col xs={6} lg={3}>
          <Label className="mb-0 model-label-name">
            Type of Sales Activities
          </Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.activityTypeName)}
          </Label>
        </Col>
        <Col xs={6} lg={3}>
          <Label className="mb-0 model-label-name">
            Activation Date & time
          </Label>
          <br />
          <Label className="mb-0 model-label-value">
            {moment
              .utc(activity?.activityStartDate)
              .format('DD-MM-YYYY hh:mm A')}
          </Label>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xs={6} md={4} lg={2}>
          <Label className="mb-0 model-label-name">Zone</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.zoneName)}
          </Label>
        </Col>
        <Col xs={6} md={4} lg={2}>
          <Label className="mb-0 model-label-name">State</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.stateName)}
          </Label>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <Label className="mb-0 model-label-name">District</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.districtName)}
          </Label>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <Label className="mb-0 model-label-name">City / Village</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.cityName)}
          </Label>
        </Col>
        <Col xs={6} md={4} lg={2}>
          <Label className="mb-0 model-label-name">Pincode</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.pincode)}
          </Label>
        </Col>
      </Row>
      {/* <Row className="mt-4"></Row> */}
      <Row className="mt-4">
        <Label for="assignees" className="header-style">
          Assigned To
        </Label>
        <KTable
          data={activity?.employeeList ?? []}
          tableParentClass=""
          columnHeader={AssignedEmpColumnHeader}
          locationData={locationData}
          onAction={() => {}}
          isLoading={false}
          showNoDataFoundMsg={false}
        />
      </Row>
      <Row className="mt-2">
        <Label for="comments" className="header-style">
          Comments
        </Label>
        <div className="bg-comment p-4 my-2 mx-2 rounded">
          <div className="bg-white rounded border px-4 pt-3 pb-3">
            <Label for="comment" className="model-comment-title">
              Log Details
            </Label>
            <div className="modal-log-div">
              <ul className="li-item model-log-value">
                {activity?.notes?.map((noteItem: any, index: number) => (
                  <li className="mt-1" key={`noteItem-li-${String(index)}`}>
                    {getUTCDate(noteItem)}
                    {noteItem.notesDescription}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </Row>
    </div>
  );
  return getDetails();
};

export default MarketingActivityDetails;
